import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import { CADASTRAR_CONFIGURACAO_CONSUMO_PONTO} from '../types'
import { URL } from '../../util/ambienteActions';

export default function cadastrarConfiguracaoConsumoPontos (configuracao, empresa) {
    const url = `${URL}/configuracao-ponto/empresa/${empresa}/consumo-pontos`;
    return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_CONFIGURACAO_CONSUMO_PONTO,
        payload: response
      })
    );
  }